<template>
  <div class="wh100">
    <LayoutTopFilter
      title="水质一览"
      style="background: #fff"
      content-class="custom-content"
    >
      <template slot="filter">
        <el-form ref="form" :model="form" :inline="true" :rules="form.rules">
          <el-form-item prop="beginTime" v-if="form.dataType == 'year'">
            <el-date-picker
              v-model="form.beginTime"
              :type="form.timeType"
              placeholder="开始时间"
              :format="form.timeFormat"
              :value-format="form.timeFormat"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="endTime" v-if="form.dataType == 'year'">
            <el-date-picker
              v-model="form.endTime"
              :type="form.timeType"
              placeholder="结束时间"
              :format="form.timeFormat"
              :value-format="form.timeFormat"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>

          <el-form-item prop="beginTime" v-if="form.dataType == 'quarter'">
            <QuarterPicker
              ref="QuarterPicker1"
              :defaultValue="form.beginTime"
              @chooseSeason="beginSeasonChange"
            ></QuarterPicker>
          </el-form-item>
          <el-form-item prop="endTime" v-if="form.dataType == 'quarter'">
            <QuarterPicker
              ref="QuarterPicker2"
              :defaultValue="form.endTime"
              @chooseSeason="endSeasonChange"
            ></QuarterPicker>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="selectedChannelIDs"
              multiple
              collapse-tags
              clearable
              placeholder="请选择指标"
              @change="ChannelChane"
            >
              <el-option
                v-for="item in channelList"
                :key="item.ChannelMap"
                :label="item.ChannelName"
                :value="item.ChannelMap"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="QueryData"
              >查询</el-button
            >
          </el-form-item>
          <el-radio-group style="margin-right: 10px" v-model="form.dataType">
            <el-radio-button label="quarter">季度</el-radio-button>
            <el-radio-button label="year">年度</el-radio-button>
          </el-radio-group>
        </el-form>
      </template>
      <template slot="content">
        <LayoutLeftCollapse>
          <template slot="left">
            <MyPanel>
              <StationTree
                @checkchange="treechange"
                @loaded="loaded"
              ></StationTree>
            </MyPanel>
          </template>
          <template slot="right-content">
            <MyPanel>
              <MyTable
                :url="tableUrl"
                :params="form"
                ref="myTable"
                :default-sort="{ prop: 'StationName', order: 'descending' }"
                :customSort="true"
                :index-column="true"
                border
                fit
              >
                <template slot="columns">
                  <el-table-column
                    prop="StationName"
                    label="断面名称"
                    align="center"
                    width="100"
                    sortable
                  ></el-table-column>
                  <el-table-column
                    prop="Year"
                    label="年度"
                    width="100"
                    align="center"
                    sortable
                  ></el-table-column>
                  <el-table-column
                    prop="Quarter"
                    label="季度"
                    width="100"
                    align="center"
                    sortable
                    v-if="form.dataType == 'quarter'"
                  ></el-table-column>
                  <template v-for="(item, index) in colArr">
                    <el-table-column
                      v-if="item.ChannelMap == 'WaterLevel'"
                      align="center"
                      show-overflow-tooltip
                      :prop="item.ChannelMap"
                      :label="item.ChannelName"
                      :key="'columns' + index"
                    >
                      <template slot-scope="scope">
                        <span
                          v-if="scope.row.WaterLevel >= 1"
                          :style="{
                            color: $util.getLevelColor(scope.row.WaterLevel),
                          }"
                        >
                          {{ $util.getLevel(scope.row.WaterLevel) }}</span
                        >

                        <span v-else style="">--</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-else
                      align="center"
                      show-overflow-tooltip
                      :prop="item.ChannelMap"
                      :label="item.ChannelName"
                      :key="'columns' + index"
                    ></el-table-column>
                  </template>
                </template>
              </MyTable>
            </MyPanel>
          </template>
        </LayoutLeftCollapse>
      </template>
    </LayoutTopFilter>
  </div>
</template>

<script>
import LayoutLeftCollapse from "../../components/layout/LayoutLeftCollapse";
import LayoutTopFilter from "../../components/layout/LayoutTopFilter";
import MyPanel from "../../components/Pannel/Pannel";
import StationTree from "../../views/DataAnalysis/components/StationTree";
import MyChart from "../../components/EChart";
import QuarterPicker from "../../views/DataAnalysis/components/QuarterPicker";
import MyTable from "../../components/PageTable";
export default {
  
  components: {
    LayoutLeftCollapse,
    LayoutTopFilter,
    MyPanel,
    StationTree,
    MyChart,
    QuarterPicker,
    MyTable,
  },
  data() {
    return {
      loading: false,
      channelList: [],
      selectedChannelIDs: "", //选中的指标iD集合
      tableUrl: "/DataManage/GetWaterData_Page_Ex",
      form: {
        beginTime: this.$util.getSeason(-3),
        endTime: this.$util.getSeason(0),
        stations: "",
        dataType: "quarter",
        rules: {
          beginTime: [
            { required: true, message: "请选择开始时间", trigger: "blur" },
          ],
          endTime: [
            { required: true, message: "请选择结束时间", trigger: "blur" },
          ],
        },
        //时间格式
        timeFormat: "yyyy-MM-dd HH:mm",
        timeType: "datetime",
      },
      colArr: [],
    };
  },
  methods: {
    ChannelChane(val) {
      this.colArr = [];
      this.channelList.some((item, i) => {
        if (this.selectedChannelIDs.indexOf(item.ChannelMap) != -1)
          this.colArr.push(item);
      });
    },
    beginSeasonChange(val) {
      this.form.beginTime = val;
    },
    endSeasonChange(val) {
      this.form.endTime = val;
    },
    treechange(arr) {
      this.form.stations = arr.join(",");
    },
    loaded(stationid) {
      this.form.stations = stationid.join(",");
      this.QueryData();
    },
    QueryData() {
      let that = this;
      if (!that.form.stations) {
        that.$message.error("请选择站点");
        return;
      }
      that.$refs["form"].validate((valid) => {
        if (valid) {
          that.$refs.myTable.reload();
        }
      });
    },
    GetChannelList() {
      let that = this;
      that.$api.get(
        "/Channel/GetChannelInfo",
        null,
        function (res) {
          if (res.code == 200) {
            that.channelList = res.data;
            res.data.some((item, i) => {
              that.selectedChannelIDs.push(item.ChannelMap);
              that.colArr.push(item);
              if (i == 10) {
                return true;
              }
            });
          }
        },

        function () {},
        true
      );
    },
  },
  mounted() {
    let that = this;
    that.GetChannelList();
    that.form.endTime = this.$util.getSeason(0);
    that.form.beginTime = this.$util.getSeason(-3);
  },
  created() {},
  computed: {},
  watch: {
    "form.dataType"(newValue, oldValue) {
      let now = new Date();
      switch (newValue) {
        case "quarter":
          this.form.endTime = this.$util.getSeason(0);
          this.form.beginTime = this.$util.getSeason(-3);
          break;
        case "year":
          this.form.endTime = this.$util.formatDate(now, "yyyy");
          this.form.timeFormat = "yyyy";
          this.form.timeType = "year";
          this.form.beginTime = this.$util.formatDate(
            new Date(new Date(now.setFullYear(now.getFullYear() - 3))),
            "yyyy"
          );
          break;

        default:
          break;
      }
      this.QueryData();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.custom-content {
  background: @backcolor;
  padding: 0 !important;
}
</style>